module.exports = __webpack_public_path__ + "static/media/create new event.cb394b60.png";